import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-table-card-sub-header',
  templateUrl: 'table-card-sub-header.component.html',
  styleUrls: ['table-card-sub-header.component.scss']
})
export class TableCardSubHeaderComponent {
}
